var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProcure = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 90 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.052 43.861c0 20.85 16.961 37.812 37.81 37.812v6.05C19.677 87.724 0 68.048 0 43.862 0 19.676 19.677.001 43.862.001c24.186 0 43.863 19.675 43.863 43.86h-6.052c0-20.848-16.962-37.81-37.81-37.81-20.85 0-37.811 16.962-37.811 37.81Zm83.944 41.892L65.983 61.74a7.618 7.618 0 0 1 2.864-.56h19.028v-6H68.846c-7.535 0-13.666 6.13-13.666 13.667v19.027h6V68.847c0-1.013.202-1.978.56-2.864l24.012 24.012 4.243-4.242Z",
  fill: "currentColor"
})));
export default SvgProcure;